import React from 'react'

export function Tos() {
  return (
    <div style={{ height: '100%', overflowY: 'auto', margin: '20px' }}>
      <nav className="navbar navbar-default navbar-fixed-top navbar-shrink">
        <div className="container">
          <div className="navbar-header page-scroll">
            <a className="navbar-brand page-scroll" href="https://dhundhoo.com/index.html" style={{ color: 'black', fontSize: '20px' }}><strong>Dhundhoo</strong></a>
          </div>
        </div>
      </nav>


      <div className="container" id="auto">
        <br />
        <p align="center">
          <strong><u>Terms of Service</u></strong>
        </p>
        <br />
        <p>
          This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions
          pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer
          system and does not require any physical or digital signatures.
        </p>
        <br />
        <p>
          This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that
          require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> .
        </p>
        <br />
        <p>
          <a href=""><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>
          (hereinafter referred to as "Website") is the exclusive property of Trackula Services Pvt Ltd with its registered office at # Plot No.442, Hari Darshan
          Sindhu Balodyan, Jaripatka Nagpur- 440014, Maharashtra, India.
        </p>
        <br />
        <p>
          Your use of the Website is governed by the following terms and conditions (“Terms of Use”) as applicable to the Website including the applicable policies
          which are incorporated herein by way of reference. If you browse, access, secure access to the Website, You shall be subject to all the policies and terms
          mentioned herein. By merely accessing or securing access, browsing the Website, You shall be contracting with    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> , Trackula Services Pvt Ltd and these terms and
          conditions including the policies constitute your binding obligations, with    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> , Trackula Services Pvt Ltd.
        </p>
        <br />
        <p>
          For the purpose of these Terms of Use, wherever the context so requires ‘You’ or “User” shall mean any natural or legal person browsing, accessing or who
          has registered on the Website by providing Registration Data while registering on the Website as Registered User using Computer, Mobile phones, Tablets.
        </p>
        <br />
        <p>
          <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>
          allows users to surf, browse the Website without registering on the Website. The term “we”, “us”, “our” shall Trackula Services Pvt Ltd.
        </p>
        <br />
        <p>
          We reserve the right, at our sole discretion, to change, modify, add or remove portions of these Terms of Use, at any time without any prior written notice
          to you. It is your responsibility to review these Terms of Use periodically for updates / changes. Your continued use of the Website, following the posting
          of changes shall indicate your consent and acceptance to such revisions
        </p>
        <br />
        <p>
          As long as you comply with these Terms of Use, We grant you a personal, non-exclusive, non-transferable, limited privilege to enter, access, use the
          Website.
          <br />
          <br />
          ACCESSING, BROWSING THE WEBSITE, REGISTERING ON THE WEBSITE INDICATE YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS, SO PLEASE READ THE TERMS AND
          CONDITIONS CAREFULLY BEFORE PROCEEDING. By impliedly or expressly accepting these Terms of Use, You also accept and agree to be bound by the Privacy Policy
          and legal policies mentioned on <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>
        </p>
        <br />
        <p>
          <strong>ONLINE PLATFORM </strong>
          <strong></strong>
        </p>
        <br />
        <p>
          Trackula Services Pvt Ltd is an intermediary and offers an online shopping platform through the Website
          <br />
          (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ). The website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) is an online shopping platform designed in a
          manner to connect the third party vendors and their customers. The online shopping platform provides access to various categories of products offered by
          the third party vendors and facilitates services like logistic services etc.
        </p>
        <br />
        <p>
          You understand, acknowledge and accept that the online platform i.e.    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> is only a mere facilitator.
        </p>
        <br />
        <p>
          <strong>TERMS OF ONLINE SHOPPING PLATFORM</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          You understand, agree and acknowledge that the online shopping platform will feature various third party vendors intending to showcase, sell their
          products. The Website shall however, take no responsibility in any manner for the content, products, descriptions, invoices generated and uploaded by the
          third party vendors.
        </p>
        <br />
        <p>
          The third party vendor are independent professionals, and Trackula Services Pvt Ltd, Website shall have no responsibility, liability in whatsoever manner.
        </p>
        <br />
        <p>
          1. The online platform (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) is only a mere facilitator of
          information, content, images, products offered, provided, uploaded by the third party vendors
        </p>
        <br />
        <p>
          2. All content, information, images, products shared and uploaded by the third party vendors are only displayed on the online platform (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> )
        </p>
        <br />
        <p>
          3. The online platform (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) shall not endorse or advise or
          involve in whatsoever manner in such content, descriptions products offered and uploaded by any third party including but not limited to any warranties
        </p>
        <br />
        <p>
          4. The online platform (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) shall not in whatsoever manner
          resolve or mediate any dispute or disagreement between the third party vendors and their customers
        </p>
        <br />
        <p>
          5. The online platform (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) shall not make any
          representation to the content, information, images, products offered and uploaded by any third party vendor on the Website
        </p>
        <br />
        <p>
          6. You understand, acknowledge and accept that the online platform provided through the Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> )shall not held liable in whatsoever manner for any but
          not limited to actions, commissions, misconduct, fraud or negligence of any third party vendor
        </p>
        <br />
        <p>
          <strong>TERMS OF USE</strong>
          <br /><br />
          This Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) shall be used only by persons who can
          form legally binding contracts under Indian Contract Act, 1872. Persons who are "incompetent to contract" within the meaning of the Indian Contract Act,
          1872 including minors, un-discharged insolvents etc. are not eligible to use this Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ). If you are a minor i.e. under the age of 18 years,
          you shall not register as a member of the Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> )
          and shall not use Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ). As a minor if you wish to
          use or transact on Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ), such use may be made by
          your legal guardian or parents on the Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ). The
          Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) reserves the right to terminate your
          Registration and / or refuse to provide you with access to the Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) if it is brought to the Website‘s notice or if it is
          discovered that you are under the age of 18 years.
        </p>
        <br />
        <p>
          <strong>REGISTRATION &amp; NO CHARGES</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          The website does not charge any fee for browsing, creating an account on the Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>). In particular,    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> may at its sole discretion introduce new services and
          modify some or all of the existing services offered on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App). In such an event, the website
          reserves the right to introduce fees for the new services offered or amend/introduce fees for existing services, as the case may be. Changes to the Fee
          Policy shall be posted on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) and such changes shall automatically become effective
          immediately after they are posted on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App). Unless otherwise stated, all fees shall be
          quoted in Indian Rupees. You shall be solely responsible for compliance of all applicable laws including those in India for making payments to    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>
        </p>
        <br />
        <p>
          <strong>WEBSITE (</strong>
          <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>
          <strong>)’s TERMS OF USE</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          You agree, undertake and confirm that your use of Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) shall be strictly governed by the following binding
          principles. You hereby agree not to use the Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> )
          to:-
          <br />
          (a) harass or advocate harassment of another person;
          <br />
          (b) involve the transmission of "junk mail”, "chain letters”, or unsolicited mass mailing or "spamming";
          <br />
          (c) promote illegal activities or conduct that is abusive, threatening, obscene, defamatory or libelous;
          <br />
          (d) infringe upon or violates any third party's rights [including, but not limited to, intellectual property rights, rights of privacy (including without
          limitation unauthorized disclosure of a person's name, email address, physical address or phone number) or rights of publicity];
          <br />
          (e) promote an illegal or unauthorized copy of another person's copyrighted work such as providing pirated computer programs or links to them, providing
          information to circumvent manufacture-installed copy-protect devices
          <br />
          (f) provide material that exploits people in a sexual, violent or otherwise inappropriate manner or solicits personal information from anyone;
          <br />
          (g) provide instructional information about illegal activities such as making or buying illegal weapons, violating someone's privacy, or providing or
          creating computer viruses;
          <br />
          (h) upload, share, transmit video, photographs, or images of another person (with a minor or an adult).
          <br />
          (i) to gain or attempt to gain unauthorized access or exceeds the scope of authorized access to the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo
          Mobile App) or to account information or other areas of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or solicits passwords or
          personal identifying information for commercial or unlawful purposes from other users;
          <br />
          (j) engage in commercial activities and/or sales without our prior written consent of the Website such as contests, sweepstakes, barter, advertising and
          pyramid schemes etc. related to the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App). Throughout this Terms of Use, ,<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>‘s prior written consent means a communication coming from    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ‘s Legal Department, categorically in response to your
          request, and categorically addressing the activity or conduct for which you seek authorization;
          <br />
          (k) solicit gambling or engage in any gambling activity which We, in Our sole discretion, believe is or could be construed as being illegal;
          <br />
          (l) interfere with another user's use and enjoyment of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or any other individual's user
          and enjoyment of similar services;
          <br />
          (m) harm minors in any way;
          <br />
          (n) infringe any patent, trademark, copyright or other proprietary rights or third party’s trade secrets or rights of publicity or privacy or shall not be
          fraudulent or involve the sale of counterfeit or stolen items including images, pictures, information, data;
          <br />
          (o) violate any law for the time being in force;
          <br />
          (p) spread, transmit, upload software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of
          any computer resource; or contains any trojan horses, worms, time bombs, cancelbots, easter eggs or other computer programming routines that may damage,
          detrimentally interfere with, diminish value of, surreptitiously intercept or expropriate any system, data or personal information;
          <br />
          (q) threaten the unity, integrity, defence, security or sovereignty of India, friendly relations with foreign states, or public order or causes incitement
          to the commission of any cognizable offence or prevents investigation of any offence or is insulting any other nation.
          <br />
          (r) to offer, attempt to offer, trade or attempt to trade in any item, the dealing of which is prohibited or restricted in any manner under the provisions
          of any applicable law, rule, regulation or guideline for the time being in force.
        </p>
        <br />
        <p>
          (s)You shall not create liability for us or cause us to lose (in whole or in part) the services of our ISPs or any third parties including individuals,
          companies, entities, organisations etc.<strong></strong>
        </p>
        <br />
        <p>
          <strong>PROHIBITED USE OF WEBSITE (WWW.DHUNDHOO.COM, WWW.DHUNDHOO.IN, DHUNDHOO MOBILE APP)</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          1. You shall not use any “deep-link”, “page-scrape”, “robot”, “spider” or other automatic device, program, algorithm or methodology, or any similar or
          equivalent manual process, to access, acquire, copy or monitor any portion of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or any
          Content, or in any way reproduce or circumvent the navigational structure or presentation of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo
          Mobile App) or any Content, to obtain or attempt to obtain any materials, documents or information through any means not purposely made available through
          the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App). We reserve our right to bar any such activity.
        </p>
        <br />
        <p>
          2. You shall not attempt to gain unauthorized access to any portion or feature of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), or
          any other systems or networks connected to the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or to any server, computer, network, or to
          any of the services offered on or through the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), by hacking, password “mining” or any other
          illegitimate means.
        </p>
        <br />
        <p>
          3. You shall not probe, scan or test the vulnerability of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or any network connected to
          the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) nor breach the security or authentication measures on the Website (www.dhundhoo.com,
          www.dhundhoo.in, Dhundhoo Mobile App) or any network connected to the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App). You may not reverse
          look-up, trace or seek to trace any information on any other user of Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), or any other
          customer, including any account on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) not owned by You, to its source, or exploit the
          Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or any service or information made available or offered by or through the Website
          (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), in any way where the purpose is to reveal any information, including but not limited to personal
          identification or information, other than your own information, as provided for by the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App).
        </p>
        <br />
        <p>
          4. You shall not make any negative, denigrating or defamatory statement(s) or comment(s) about us or the brand name used by us including the terms Trackula
          Services Pvt Ltd, Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>) or otherwise engage in any
          conduct or action that might tarnish the image or reputation, of Trackula Services Pvt Ltd, Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) or otherwise tarnish or dilute any trade or service
          marks, trade name and/or goodwill associated with the trade or service marks, trade name as may be owned or used by us. You agree that You will not take
          any action that imposes an unreasonable or disproportionately large load on the infrastructure of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo
          Mobile App) or <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ‘s systems or networks, or any systems or
          networks connected to the website
        </p>
        <br />
        <p>
          5. You agree not to use any device, software or routine to interfere or attempt to interfere with the proper working of the Website (www.dhundhoo.com,
          www.dhundhoo.in, Dhundhoo Mobile App) or any transaction being conducted on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), or with
          any other person’s use of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App).
        </p>
        <br />
        <p>
          6. You may not forge headers or otherwise manipulate identifiers in order to disguise the origin of any message or transmittal, you send to us on or
          through the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or any service offered on or through the Website (www.dhundhoo.com,
          www.dhundhoo.in, Dhundhoo Mobile App). You may not pretend that you are, or that you represent, someone else, or impersonate any other individual or
          entity.
        </p>
        <br />
        <p>
          7. You may not use the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or any content for any purpose that is unlawful or prohibited by
          these Terms of Use, or to solicit the performance of any illegal activity or other activity which infringes the rights of Trackula Services Pvt Ltd,
          Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) and / or others.
        </p>
        <br />
        <p>
          8. You shall at all times ensure full compliance with the applicable provisions of the Information Technology Act, 2000 and rules there under as applicable
          and as amended from time to time and also all applicable laws, rules and regulations.
        </p>
        <br />
        <p>
          9. You may not transmit any chain letters or unsolicited commercial or junk email to other users via the Website (www.dhundhoo.com, www.dhundhoo.in,
          Dhundhoo Mobile App).
        </p>
        <br />
        <p>
          10. It shall be a violation of these Terms of Use to use any information obtained from the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App)
          in order to harass, abuse, or harm another person, or solicit, or sell to another person including but not limited to individuals, entities, companies,
          organisations any such information.
        </p>
        <br />
        <p>
          11. You understand that we have the right at all times to disclose any information (including the identity of the persons providing information or
          materials on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App)) as necessary to satisfy any law, regulation or valid governmental
          request. This may include, without limitation, disclosure of the information in connection with investigation of alleged illegal activity or solicitation
          of illegal activity or in response to a lawful court order or subpoena. In addition, we can (and You hereby expressly authorize us to) disclose any
          information about You to law enforcement or other government officials, as we, in our sole discretion, believe necessary or appropriate in connection with
          the investigation and/or resolution of possible crimes, especially those that may involve personal injury.
        </p>
        <br />
        <p>
          12. We reserve the right, but has no obligation, to monitor the materials posted on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App).
          The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) shall have the right to remove or edit any
          content, product, image that in its sole discretion violates, or is alleged to violate, any applicable law or either the spirit or letter of these Terms of
          Use. In no event shall Trackula Services Pvt Ltd, Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) assume or have any responsibility or liability for any
          Content posted or for any claims, damages or losses resulting from use of Content, Images, Products offered etc.
        </p>
        <br />
        <p>
          13. Your correspondence or business dealings with any third party vendor on the Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ), or participation in any of the offers/ promos hosted
          on or through the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), and any other terms, conditions, warranties or representations
          associated with such dealings, are solely between You and such third party vendor offering such promos/ offers. We shall not be responsible or liable for
          any loss or damage of any sort incurred as the result of any such dealings or as the result of the presence of third party vendors on the Website
          (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App).
        </p>
        <br />
        <p>
          14. It is possible that other Users (including unauthorized users or “hackers”) may post or transmit offensive or obscene materials on the Website
          (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) and that You may be involuntarily exposed to such offensive and obscene materials. It also is
          possible for others to obtain personal information about you due to your use of the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), and
          that the recipient may use such information to harass or injure you. We does not approve of such unauthorized uses, but by using the Website
          (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) You acknowledge and agree that we are not responsible for the use of any personal information that
          You publicly disclose or share with others on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App).
        </p>
        <br />
        <p>
          15. The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>) shall have all the rights to take
          necessary action and claim damages that may occur due to your involvement/participation in any way on your own or through group/s of people, intentionally
          or unintentionally in DoS/DDoS (Distributed Denial of Services).
        </p>
        <br />
        <p>
          <strong>CONTENTS POSTED ON THE WEBSITE </strong>
          <br /><br />
          The Platform description, Content, text, user interfaces, visual interfaces, photographs, images, pictures, trademarks, logos, and artwork relating to the
          Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>) shall be the sole property of Trackula Services
          Pvt Ltd and we have worldwide, perpetual and transferable rights in regard to such Content. We shall be entitled to, consistent with our Privacy Policy as
          adopted in accordance with applicable law, use the Content or any of its elements for any type of use forever, including but not limited to promotional and
          advertising purposes and in any media whether now known or hereafter devised, including the creation of derivative works
        </p>
        <br />
        <p>
          The content, information including information relating to products, offers, content uploaded by any third party vendor shall be herein after referred to
          as “Third Party Content”. The online shopping platform, website merely displays such third party content and shall be considered as a mere intermediary for
          this purpose.
        </p>
        <br />
        <p>
          All the intellectual property, proprietary rights arising out of such “Third Party Content” shall be the exclusive property of the respective intellectual
          property owners. We have no intention to acquire the intellectual property arising out of Third Party Content. In no event, shall Trackula Services Pvt
          Ltd, Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) hold any responsibility, liability for
          such Third Party Content.
        </p>
        <br />
        <p>
          The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) may also contain free images from the
          internet, images legally outsourced from various sources, royalty free images and in such case, the source of the images may also be mentioned and credit
          shall be given to the respective intellectual property owner.
        </p>
        <br />
        <p align="justify">
          Nothing contained herein shall be copied, reproduced, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted or distributed in
          any way (including “mirroring”) to any other computer, server, Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) or other medium for
          publication or distribution or for any commercial enterprise, without the express prior written consent of Trackula Services Pvt Ltd, Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>) .
        </p>
        <br />
        <p>
          <strong>LEGAL ACTION AGAINST THE THIRD PARTY VENDOR</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          In the event of any criminal act committed by the third party vendor or its staff or affiliate, you may take direct action under the laws of the country on
          such third party vendor or its staff or affiliate and in such cases the Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ), Trackula Services Pvt Ltd shall also be informed
          about the same.
        </p>
        <br />
        <p>
          In the occurrence of the any such event mentioned above, you shall not make the Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ), Trackula Services Pvt Ltd, a party to such
          offence, as the third party vendor or its staff or affiliates are individually and severally liable for any criminal act committed by him or her
        </p>
        <br />
        <p>
          <strong>LIABILITY DUE TO INTERNET CONNECTIVITY &amp; NETWORK ISSUES</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ), Trackula Services Pvt Ltd shall hold no
          responsibility, liability for any actions, acts including but not limited to errors, transmission, activities and issues arising out of internet
          connectivity and any other network related issues. <strong></strong>
        </p>
        <br />
        <p>
          <strong>REVIEW POLICY</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          While we encourage you to share your views and opinions on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), we expect that this will
          be done in a respectful manner. This policy is applicable to posts, comments and reviews posted by you on and/or using Website (www.dhundhoo.com,
          www.dhundhoo.in, Dhundhoo Mobile App)
        </p>
        <br />
        <p>
          The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) shall however not agree with or endorse
          every comment that individuals post on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App). When making moderation decisions, we will take
          these guidelines, as well as the context in which comments are made, into account
        </p>
        <br />
        <p>
          We share this information in an effort to be transparent about our moderation process and why certain comments may be removed. Kindly read these terms/
          guidelines while making any posts, comments, reviews on the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App)
        </p>
        <br />
        <p>
          You specifically agree not to post or transmit any comments, reviews, posts, content or engage in any activity that:-
        </p>
        <br />
        <p>
          1. Violate our Terms and Policies;
        </p>
        <p>
          2. Is harmful, threatening, abusive, harassing, tortious, indecent, defamatory, discriminatory, vulgar, profane, obscene, libelous, hateful or otherwise
          objectionable
        </p>
        <p>
          3. Violate any right, including, but not limited to, right of privacy, right of publicity, copyright, trademark, patent, trade secret, or any other
          intellectual property or proprietary rights;
        </p>
        <p>
          4. Disguising or attempting to disguise the origin of your comment, review, posts, content including but not limited to by submitting your comments, posts,
          reviews, content under a fake or false name
        </p>
        <p>
          5. Constitutes a knowingly erroneous or unethical review
        </p>
        <p>
          6. Causes, or is a result of, a conflict of interest;
        </p>
        <p>
          7. Is commercial in nature, including but not limited to posts, comments, reviews submitted in exchange for payment,
        </p>
        <p>
          8. Contains material that is not in English
        </p>
        <p>
          9. Accesses or uses the account of another user without permission;
        </p>
        <p>
          10. We reserve the right to remove any comment, review, posts, content that might be found extremely offensive or threatening.
        </p>
        <p>
          11. Please don't exaggerate, falsely state, misrepresent your experience and watch your language.
        </p>
        <p>
          12. This also includes but not is limited to derogatory comments or indication of a personal vendetta against Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ), Trackula Services Pvt Ltd and its affiliates.
        </p>
        <p>
          All links posted as comments, reviews on the Website will be reviewed and may be deleted if found violating these guidelines. Repeated violations of this
          policy may cause the author to be blocked from our Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App).
        </p>
        <br />
        <p>
          The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) shall have the right to immediately block
          your access and further it shall also have the right to remove any non-compliant comment, post, review and content forthwith, uploaded on the Website. The
          Website reserves have the right to take appropriate recourse to such remedies as would be available to it under various statutes.
        </p>
        <br />
        <p>
          <strong>USER OBLIGATIONS</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          1. You shall be obliged to provide accurate information and other details to us<strong></strong>
        </p>
        <p>
          2. You shall also adhere to the minimum age requirement i.e. 18 years as defined by the law of the land <strong></strong>
        </p>
        <p>
          3. You shall read all the policies, terms mentioned in the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App)<strong></strong>
        </p>
        <p>
          4. You shall not copy or use the information contained in the Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) <strong></strong>
        </p>
        <p>
          5. You shall ensure compliance to the User Review policy contained herein <strong></strong>
        </p>
        <p>
          6. You shall be responsible for all and acts arising out of your account <strong></strong>
        </p>
        <p>
          7. You shall be responsible for ensuring reasonable security measures regarding your login credentials and in event shall the Website, Trackula Services
          Pvt Ltd be responsible or liable in this regard<strong></strong>
        </p>
        <p>
          8. You shall be responsible for all orders, purchases made using or on the website <strong></strong>
        </p>
        <p>
          9. You shall be liable to furnish C-Form on the CST sale. In the event the C-Form is not furnished, provided, then You hereby accept that You shall be
          liable for any consequences including but not limited to fines, legal obligations etc. <strong></strong>
        </p>
        <p>
          10. You hereby agree that in the event , any fine is to be paid by the website or third party vendor on your behalf, you shall be liable to pay such amount
          in full and complete back to the website or third party vendor along with the interest as notified to you by the website or the third party vendor    <strong></strong>
        </p>
        <p>
          11. You shall be responsible for ensuring prompt payment for products ordered or purchased on and/ through the Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ), i.e. the online shopping platform    <strong></strong>
        </p>
        <br />
        <p>
          <strong>PRIVACY</strong>
          <br /><br />
          We view protection of Your privacy as a very important principle. We understand clearly that You and Your Sensitive Personal Information is one of our most
          important assets. We store and process Your Sensitive Personal Information including any sensitive financial information collected (as defined under the
          Information Technology Act, 2000), if any, on computers that may be protected by physical as well as reasonable technological security measures and
          procedures in accordance with Information Technology Act 2000 and Rules there under. Our Privacy Policy is available for more details.
        </p>
        <br />
        <p>
          <strong></strong>
        </p>
        <p>
          <strong>LEGAL DISCLAIMER</strong>
          <strong>
            <br />
          </strong>
          <br />
          This Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App), all the services, included on or otherwise made available to You through this
          Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) are provided on “as is” and “as available” basis without any representation or warranties,
          express or implied except otherwise specified in writing. Without prejudice to the forgoing paragraph, the Website does not warrant that:-
        </p>
        <br />
        <p>
          i. This Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) will be constantly available, or available at all; or the information on this
          Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) is complete, true, accurate or non-misleading.
        </p>
        <p>
          ii. The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) does not warrant that this site;
          information, Content, materials, images, product (including software) or services included on or otherwise made available to You through the Website
          (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App); their servers; or electronic communication sent from us are free of viruses or other harmful
          components.
        </p>
        <br />
        <p>
          Nothing on Website (www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App) constitutes, or is meant to constitute, advice of any kind.
        </p>
        <br />
        <p>
          We disclaim any damages, liabilities, loss, claims including ANY SPECIAL, INCIDENTAL, INDIRECT or CONSEQUENTIAL DAMAGES OF ANY KIND IN CONNECTION OR
          ARISING OUT OF YOUR USE OF THE WEBSITE.
        </p>
        <br />
        <p>
          You will be required to enter a valid name, phone number and email id while availing registering on the Website (www.dhundhoo.com, www.dhundhoo.in,
          Dhundhoo Mobile App). By registering your phone number with us, you consent to be contacted by us via phone calls and / or SMS notifications, in case of
          any updates.
        </p>
        <br />
        <p>
          <strong>INDEMNITY</strong>
          <br /><br />
          You shall indemnify and hold harmless the Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ),
          Trackula Services Pvt Ltd, its Director, affiliates, subsidiaries, group companies (as applicable) and their respective officers, directors, agents, and
          employees, from any claim or demand, or actions, damage claims made by any third party or penalty imposed due to or arising out of Your breach of this
          Terms of Use, privacy Policy and other Policies, or Your violation of any law, rules or regulations or the rights (including infringement of intellectual
          property rights) of a third party.
        </p>
        <br />
        <p>
          <strong>APPLICABLE LAW / JURISDICTION </strong>
          <br /><br />
          Terms of Use shall be governed by and interpreted and construed in accordance with the laws of India. The place of jurisdiction shall be exclusively in
          Hyderabad
        </p>
        <br />
        <p>
          <strong>DESCRIPTION</strong>
        </p>
        <br />
        <p>
          The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) does not ensure that the content including
          description, data and information thereof is accurate, complete, reliable, current, or error-free and assumes no liability in this regard.
        </p>
        <br />
        <p>
          The Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ) may include inaccuracies and typographical
          errors. Changes and improvements are periodically made to the site and the information therein. We do not warrant or assume any legal liability or
          responsibility for the completeness, or usefulness of any information, content, blogs etc. Information received via this Website (www.dhundhoo.com,
          www.dhundhoo.in, Dhundhoo Mobile App) should not be relied upon for personal, legal or financial decisions.
        </p>
        <br />
        <p>
          <strong>SHIPPING POLICY</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          All products purchased or order through the Website (<a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> ) shall be shipped as per the
          shipping time and shipping charges provided by our logistic partner and shall be specifically mentioned for each product which shall be mentioned on the
          Website.
        </p>
        <br />
        <p>
          However, the shipping time &amp; shipping charges shall vary from product to product based on the delivery locations as well. The shipping charges
          mentioned are estimated, however, in case of any additional charges, such additional charges shall be intimated to You and You shall be responsible for
          payment of such additional charges.
        </p>
        <br />
        <p>
          <strong>ONLINE PAYMENT</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          In order to facilitate payments for the products purchased by You through the Website , the website offers an online payment gateway facility that will
          facilitate You to make payments in respect thereof the products purchased through the Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> )using net banking, credit/debit card account or
          any other mode acceptable and made available to the users from time to time, subject to Your complete acceptance and adherence to the terms and conditions
          hereof as well as the terms and conditions of the website of the payment gateway service provider/s.
        </p>
        <br />
        <p>
          <strong>CREDIT CARD PAYMENT</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          Your credit card details shall be transferred directly to our payment service provider for immediate authorization and are not recorded or stored in our
          database. Once we have received authorization from the payment service provider, we shall confirm your service order.
        </p>
        <br />
        <p>
          Further:
        </p>
        <p>
          1.You have categorically authorized www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App to collect, process, facilitate and remit payments and / or
          electronically from other Users in respect of transactions through Payment Facility. Your relationship with    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a>is on a principal to principal basis and by accepting these Terms of Use you agree
          that <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> is an independent contractor for all purposes,
          and does not have control of or liability for the products that are listed on    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> that are paid for by using the Payment gateway
        </p>
        <p>
          2. You understand, accept and agree that the payment facility provided by    <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> is neither a banking nor financial service but is
          merely a facilitator providing an electronic, automated online electronic payment, collection and remittance facility for the Transactions on    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> using the existing authorized banking
          infrastructure and Credit Card payment gateway networks. Further, by providing Payment Facility,    <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> is neither acting as trustees nor acting in a
          fiduciary capacity with respect to the Transaction or the Transaction Price
        </p>
        <p>
          3. <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> reserves the right to impose limits on the number
          of Transactions or Transaction Price which Foodster may receive from on an individual Valid Credit/ Debit/ Cash Card / Valid Bank Account/ and such other
          infrastructure or any other financial instrument directly or indirectly through payment aggregator or through any such facility authorized by Reserve Bank
          of India to provide enabling support facility for collection and remittance of payment or by an individual User during any time period, and reserves the
          right to refuse to process Transactions exceeding such limit.
        </p>
        <p>
          4. <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> reserves the right to refuse to process
          Transactions by Users with a prior history of questionable charges including without limitation breach of any agreements by User with    <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> or breach / violation of any law or any charges
          imposed by Issuing Bank or breach of any policy.
        </p>
        <p>
          5. In the event, <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> is not satisfied with the
          creditability of the User, it will have the right to reject the receipt of / Users
        </p>
        <p>
          6. <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> may delay notifying the payment confirmation, if
          www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App deems suspicious or for Users conducting high transaction volumes to ensure safety of the
          Transaction and Transaction Price. In addition, <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> may
          hold the service and may not provide service at the request of law enforcement officials or in the event the user is engaged in any form of illegal
          activity.
        </p>
        <p>
          7. The user acknowledges that <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a> will not be liable for
          any damages, interests or claims etc. resulting from not processing a Transaction / Transaction Price or any delay in processing a Transaction /
          Transaction Price which is beyond control of <a href="http://www.dhundhoo.in"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App </u></a>
        </p>
        <br />
        <p>
          <strong>CASH ON DELIVERY (COD) ORDERS</strong>
          <strong></strong>
        </p>
        <br />
        <p>
          All cash on delivery order payments have to be made at the time of order delivery to our logistics partner. The Products would be handed over to the You
          only after receipt of the payment for the Products.
        </p>
        <br />
        <p>
          <strong>DELIVERY POLICY </strong>
          <strong></strong>
        </p>
        <br />
        <p>
          Our logistics partner shall make all reasonable efforts to deliver the Products ordered by You at the delivery address mentioned by You at the time of
          placing the order. However, in case You are unable to take the delivery of the Product, the same shall be returned back to the third party vendor. In some
          cases, the order may be dispatched in separate parcels. However, in case of wrong shipment, order mismatch, damaged or broken products, the same shall be
          intimated to us and shall be returned to our logistic partner and the same shall be returned to the respective third party vendor offering such product or
          products. In such events, the same shall be intimated by You within the timeline as mentioned in the website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> )
        </p>
        <br />
        <p>
          <strong>CANCELLATION POLICY </strong>
          <strong></strong>
        </p>
        <br />
        <p>
          You may cancel the order(s) placed through the Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ). However, such cancellation shall be acceptable
          if done within a time period prescribed on the Website (    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com, www.dhundhoo.in, Dhundhoo Mobile App</u></a> ). All such cancellations shall attract the payment
          of a cancellation fee as mentioned herein. However, in some events, the Website shall cancel your orders without any cancellation fee for reasons including
          but not limited to any wrong deals regarding price, products, product quality, vendor and/ your credentials
        </p>

        <br />
        <div>
          <span className="copyright">Copyright © Trackula Services Pvt Ltd 2018</span>
        </div>
        <br />

      </div>
    </div>

  )
}

export default Tos